var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('infiniteLoading',{attrs:{"identifier":_vm.identifier},on:{"infinite":_vm.infinite}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})])}
var staticRenderFns = []

export { render, staticRenderFns }